// Navigation entry for the Timeline screen, behind the global admin flag.

export const TIMELINE_FLAG = 'timeline_screen_enabled';
export const TIMELINE_SCREEN = 'ProjectTimeline';

/** Drops the Timeline item from a nav category list while the flag is off. */
export function withTimelineNav<T extends { key: string; items: Array<{ screen: string }> }>(
  categories: T[],
  timelineOn: boolean,
): T[] {
  if (timelineOn) return categories;
  return categories.map((cat) =>
    cat.items.some((it) => it.screen === TIMELINE_SCREEN)
      ? { ...cat, items: cat.items.filter((it) => it.screen !== TIMELINE_SCREEN) }
      : cat,
  );
}
